import { 
  gas1, gas2, gas3, gas4, gas5, gas6, gas7, gas8, gas9, gas10, gas11, gas12, gas13, gas14, gas15, gas16, gas17,  gas18,  gas19,  gas20,  gas21,  gas22,  gas23,  gas24,  gas25,  gas26,  gas27,

  bedheadunit1, bedheadunit2, bedheadunit3, bedheadunit4, bedheadunit5, bedheadunit6, bedheadunit7, bedheadunit8, bedheadunit9, bedheadunit10,  bedheadunit11, bedheadunit12,

  Adapter1,  Adapter2,  Adapter3,  Adapter4,  Adapter5,  Adapter6,  Adapter7,    Adapter8,  Adapter9,  Adapter10,  Adapter11,  Adapter12,  Adapter13,  Adapter14,  Adapter15,  Adapter16,  Adapter17,  Adapter18,  Adapter19,  Adapter20,  Adapter21,  Adapter22,  Adapter23,  Adapter24,  Adapter25,  Adapter26,  Adapter27,  Adapter28,  Adapter29,  Adapter30,  Adapter31,  Adapter32,  Adapter33, 

  lab1, lab2, lab3, lab4, lab5, lab6, lab7, lab8, lab9, lab10, lab11, lab12, lab13, lab14, lab15, lab16, 

  pendant1, pendant2, pendant3, pendant4, pendant5, pendant6, pendant7, pendant8, pendant9, pendant10,

  functionbed, functionselectricbed, walkingframe, traumastretcher, gynecologyexaminationbed, deliverybed, foldingchair, recliningchair, manualbed, theatre1, theatre2, theatre3, theatre4, theatre5, theatre6, theatre7, theatre8, bed1, cabinets, blinds,

  analyser1, analyser2, analyser3, analyser4, analyser5, analyser6, analyser7, analyser8, analyser9, analyser10, analyser11, analyser12, analyser13, analyser14, analyser15,

  ultrasoundtrolley, anaesthesiamachine, ultrasoundoxyaider, anaestheticmachine, ultrasoundmachine, resuscitator, ultrasoundtrolley1,  ultrasoundtrolley2, HBMaternityMonitor, BPMonitor,

  xraylow, xrayhigh, xray1, xray2, xray3, xray4, xray5, xray6, xray7, xray8, xray9, xray10, xray11,

  light1, light2, light3, light4, light5, light6, light7, light8, light9, light10, light11, light12, light13,

  dentalvacuum, dentalapex, dentalairmotor, aircompressor1, aircompressor2, aircompressor3, aircompressor4, aircompressor5, aircompressor6, aircompressor7, aircompressor8, dentalchair1, dentalchair2, dentalchair3, dentalchair4, dentalchair5, dentalchair6, dentalchair7,

  cabinet1, cabinet2, cabinet3, cabinet4, cabinet5, cabinet6, cabinet7, cabinet8, cabinet9,

  monitor1, monitor2, monitor3, monitor4, monitor5, monitor6, monitor7,

  suction1, suction2, suction3, suction4,

  cssd1, cssd2, cssd3, cssd4, cssd5, cssd6, cssd7, cssd8, cssd9,
  } from "../../assets"


const allProducts = [
//Medical gases | Piping
  {
    id: 101,
    category: 'Medical Gases | Piping',
    cover: gas1,
    name: "",
    price: 100,
  },
  {
    id: 102,
    category: 'Medical Gases | Piping', 
    cover:   gas2,
    name: "",
    price: 20,
  },
  {
    id: 103,
    category: 'Medical Gases | Piping',
    cover:   gas3,
    name: "",
    price: 200,
  },
  {
    id: 104,
    category: 'Medical Gases | Piping',
    cover:   gas4,
    name: "",
    price: 50,
  },
  {
    id: 105,
    category: 'Medical Gases | Piping',
    cover:   gas5,
    name: "",
    price: 100,
  },
  {
    id: 106,
    category: 'Medical Gases | Piping',
    cover:   gas6,
    name: "",
    price: 100,
  },
  {
    id: 107,
    category: 'Medical Gases | Piping',
    cover:   gas7,
    name: "",
    price: 100,
  },
  {
    id: 108,
    category: 'Medical Gases | Piping',
    cover:  gas8,
    name: "",
    price: 100,
  },
  {
    id: 109,
    category: 'Medical Gases | Piping',
    cover:   gas9,
    name: "",
    price: 100,
  },
  {
    id: 110,
    category: 'Medical Gases | Piping',
    cover:   gas10,
    name: "",
    price: 100,
  },
  {
    id: 111,
    category: 'Medical Gases | Piping',
    cover:   gas11,
    name: "",
    price: 100,
  },
  {
    id: 112,
    category: 'Medical Gases | Piping',
    cover:   gas12,
    name: "CYLINDER X CYLINDER FULLY AUTO DIGITAL - MODEL CCU",
    price: 100,
  },
  {
    id: 113,
    category: 'Medical Gases | Piping',
    cover:   gas13,
    name: "LIQUID-X-LIQUID-FULLY-AUTO-DIGITAL-MODEL",
    price: 100,
  },
  {
    id: 114,
    category: 'Medical Gases | Piping',
    cover:   gas14,
    name: "Emergency Reserve Manifold",
    price: 100,
  },
  {
    id: 115,
    category: 'Medical Gases | Piping',
    cover:   gas15,
    name: "Liquid-by-Cylinder Medical Gas Manifold",
    price: 100,
  },
  {
    id: 116,
    category: 'Medical Gases | Piping',
    cover:   gas16,
    name: "vertical one valve box",
    price: 100,
  },
  {
    id: 117,
    category: 'Medical Gases | Piping',
    cover:   gas17,
    name: "Copper Reducers",
    price: 100,
  },
  {
    id: 118,
    category: 'Medical Gases | Piping',
    cover:   gas18,
    name: "",
    price: 100,
  },
  {
    id: 119,
    category: 'Medical Gases | Piping',
    cover:   gas19,
    name: "Horizontal valve box",
    price: 100,
  },
  {
    id: 120,
    category: 'Medical Gases | Piping',
    cover:   gas20,
    name: "",
    price: 100,
  },
  {
    id: 121,
    category: 'Medical Gases | Piping',
    cover:   gas21,
    name: "Generators",
    price: 100,
  },
  {
    id: 122,
    category: 'Medical Gases | Piping',
    cover:   gas22,
    name: "Gas Cylinders",
    price: 100,
  },
  {
    id: 123,
    category: 'Medical Gases | Piping',
    cover:   gas23,
    name: "Valves",
    price: 100,
  },
  {
    id: 124,
    category: 'Medical Gases | Piping',
    cover:   gas24,
    name: "Gas Tank",
    price: 100,
  },
  {
    id: 125,
    category: 'Medical Gases | Piping',
    cover:   gas25,
    name: "Oxygen Control Panel",
    price: 100,
  },
  {
    id: 126,
    category: 'Medical Gases | Piping',
    cover:   gas26,
    name: "Copper piping",
    price: 100,
  },
  {
    id: 127,
    category: 'Medical Gases | Piping',
    cover:   gas27,
    name: "Welding and cutting fullkit",
    price: 100,
  },

//Bedhead Unit
  {
    id: 200,
    category: 'Bedhead Unit',
    cover: bedheadunit1,
    name: "ARYA Bed-Head Unit",
    price: 100,
  },
  {
    id: 201,
    category: 'Bedhead Unit',
    cover:   bedheadunit2,
    name: "CAT Bed-Head Unit",
    price: 20,
  },
  {
    id: 202,
    category: 'Bedhead Unit',
    cover:   bedheadunit3,
    name: "DERIN Bed-Head Unit",
    price: 200,
  },
  {
    id: 203,
    category: 'Bedhead Unit',
    cover:   bedheadunit4,
    name: "MODULA Bed-Head Unit",
    price: 50,
  },
  {
    id: 204,
    category: 'Bedhead Unit',
    cover:   bedheadunit5,
    name: "SAHRA Bed-Head Unit",
    price: 100,
  },
  {
    id: 205,
    category: 'Bedhead Unit',
    cover:   bedheadunit6,
    name: "SOFT Bed-Head Unit",
    price: 100,
  },
  {
    id: 206,
    category: 'Bedhead Unit',
    cover:   bedheadunit7,
    name: "Bed-Head Unit",
    price: 100,
  },
  {
    id: 207,
    category: 'Bedhead Unit',
    cover:   bedheadunit8,
    name: "Bed-Head Unit",
    price: 100,
  },
  {
    id: 209,
    category: 'Bedhead Unit',
    cover:   bedheadunit9,
    name: "mobilya Bed-Head Unit",
    price: 100,
  },
  {
    id: 210,
    category: 'Bedhead Unit',
    cover:   bedheadunit10,
    name: "Bed-Head Unit",
    price: 100,
  },
  {
    id: 211,
    category: 'Bedhead Unit',
    cover:   bedheadunit11,
    name: "Bed-Head Unit",
    price: 100,
  },
  {
    id: 212,
    category: 'Bedhead Unit',
    cover:   bedheadunit12,
    name: "Bed-Head Unit",
    price: 100,
  },

//Medical Gases Adapter
  {
    id: 301,
    category: 'Medical Gases Adapter',
    cover: Adapter1,
    name: "Diaphragm Vacuum Regulator With Rail",
    price: 100,
  },
  {
    id: 302,
    category: 'Medical Gases Adapter',
    cover: Adapter2,
    name: "Oxygen Concentrators",
    price: 200,
  },
  {
    id: 303,
    category: 'Medical Gases Adapter',
    cover: Adapter3,
    name: "Medical Hoses",
    price: 100,
  },
  {
    id: 304,
    category: 'Medical Gases Adapter',
    cover: Adapter4,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 305,
    category: 'Medical Gases Adapter',
    cover: Adapter5,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 306,
    category: 'Medical Gases Adapter',
    cover: Adapter6,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 307,
    category: 'Medical Gases Adapter',
    cover: Adapter7,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 308,
    category: 'Medical Gases Adapter',
    cover: Adapter8,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 309,
    category: 'Medical Gases Adapter',
    cover: Adapter9,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 310,
    category: 'Medical Gases Adapter',
    cover: Adapter10,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 311,
    category: 'Medical Gases Adapter',
    cover: Adapter11,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 312,
    category: 'Medical Gases Adapter',
    cover: Adapter12,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 313,
    category: 'Medical Gases Adapter',
    cover: Adapter13,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 314,
    category: 'Medical Gases Adapter',
    cover: Adapter14,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 315,
    category: 'Medical Gases Adapter',
    cover: Adapter15,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 316,
    category: 'Medical Gases Adapter',
    cover: Adapter16,
    name: "xx",
    price: 100,
  },
  {
    id: 317,
    category: 'Medical Gases Adapter',
    cover: Adapter17,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 318,
    category: 'Medical Gases Adapter',
    cover: Adapter18,
    name: "",
    price: 100,
  },
  {
    id: 319,
    category: 'Medical Gases Adapter',
    cover: Adapter19,
    name: "",
    price: 100,
  },
  {
    id: 320,
    category: 'Medical Gases Adapter',
    cover: Adapter20,
    name: "",
    price: 100,
  },
  {
    id: 321,
    category: 'Medical Gases Adapter',
    cover: Adapter21,
    name: "",
    price: 100,
  },
  {
    id: 322,
    category: 'Medical Gases Adapter',
    cover: Adapter22,
    name: "",
    price: 100,
  },
  {
    id: 323,
    category: 'Medical Gases Adapter',
    cover: Adapter23,
    name: "",
    price: 100,
  },
  {
    id: 324,
    category: 'Medical Gases Adapter',
    cover: Adapter24,
    name: "",
    price: 100,
  },
  {
    id: 325,
    category: 'Medical Gases Adapter',
    cover: Adapter25,
    name: "",
    price: 100,
  },
  {
    id: 326,
    category: 'Medical Gases Adapter',
    cover: Adapter26,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 327,
    category: 'Medical Gases Adapter',
    cover: Adapter27,
    name: "",
    price: 100,
  },
  {
    id: 328,
    category: 'Medical Gases Adapter',
    cover: Adapter28,
    name: "",
    price: 100,
  },
  {
    id: 329,
    category: 'Medical Gases Adapter',
    cover: Adapter29,
    name: "Oxygen Therapy Device",
    price: 100,
  },
  {
    id: 330,
    category: 'Medical Gases Adapter',
    cover: Adapter30,
    name: "",
    price: 100,
  },
  {
    id: 331,
    category: 'Medical Gases Adapter',
    cover: Adapter31,
    name: "",
    price: 100,
  },
  {
    id: 332,
    category: 'Medical Gases Adapter',
    cover: Adapter32,
    name: "",
    price: 100,
  },
  {
    id: 333,
    category: 'Medical Gases Adapter',
    cover: Adapter33,
    name: "",
    price: 100,
  },

//Lab
  {
    id: 401,
    category: 'Lab',
    cover: lab1,
    name: "Advanced-Clinical-Centrifuge",
    price: 100,
  },
  {
    id: 402,
    category: 'Lab',
    cover: lab2,
    name: "Low-Temperature-Deep-Vertical-Freezer",
    price: 20,
  },
  {
    id: 403,
    category: 'Lab',
    cover: lab3,
    name: "Biological-Microscope",
    price: 200,
  },
  {
    id: 404,
    category: 'Lab',
    cover: lab4,
    name: "Constant Temperature and Humidity Incubator",
    price: 50,
  },
  {
    id: 405,
    category: 'Lab',
    cover: lab5,
    name: "Constant-Temperature Drying Oven",
    price: 100,
  },
  {
    id: 406,
    category: 'Lab',
    cover: lab6,
    name: "Forced Air Drying Oven",
    price: 100,
  },
  {
    id: 407,
    category: 'Lab',
    cover: lab7,
    name: "High Temperature Drying Oven",
    price: 100,
  },
  {
    id: 408,
    category: 'Lab',
    cover: lab8,
    name: "Laboratory-Pharmaceutical-Refrigerator-Oxyaider",
    price: 100,
  },
  {
    id: 409,
    category: 'Lab',
    cover: lab9,
    name: "Lighting Incubator",
    price: 100,
  },
  {
    id: 410,
   category: 'Lab',
    cover: lab10,
    name: "Low Speed Centrifuge",
    price: 100,
  },
  {
    id: 411,
    category: 'Lab',
    cover: lab11,
    name: "Low Temperature CO2 Incubator",
    price: 100,
  },
  {
    id: 412,
    category: 'Lab',
    cover: lab12,
    name: "Mini Centrifuge",
    price: 100,
  },
  {
    id: 413,
    category: 'Lab',
    cover: lab13,
    name: "Multifunctional Incubator",
    price: 100,
  },
  {
    id: 414,
    category: 'Lab',
    cover: lab14,
    name: "Vacuum Drying Oven",
    price: 100,
  },
  {
    id: 415,
    category: 'Lab',
    cover: lab15,
    name: "Laboratory-Biological-Binocular-Microscope",
    price: 100,
  },
  {
    id: 416,
    category: 'Lab',
    cover: lab16,
    name: "Centrifuge",
    price: 100,
  },


//Pendant Arm System
  {
    id: 501,
    category: 'Pendant Arm System',    
    cover: pendant1,
    name: "DOUBLE ARM MOTORIZED HEXMOD PENDANT",
    price: 100,
  },
  {
    id: 502,
    category: 'Pendant Arm System',   
    cover:   pendant2,
    name: "DOUBLE ARM MOTORIZED KALE PENDANT",
    price: 20,
  },
  {
    id: 503,
    category: 'Pendant Arm System',
    cover:   pendant3,
    name: "DOUBLE ARM NON-MOTORIZED CALE PENDANT",
    price: 200,
  },
  {
    id: 504,
    category: 'Pendant Arm System',
    cover:   pendant4,
    name: "FIXED PENDANT CASTLE",
    price: 50,
  },
  {
    id: 505,
    category: 'Pendant Arm System',
    cover:  pendant5,
    name: "FIXED PENDANT HEXMOD",
    price: 100,
  },
  {
    id: 506,
    category: 'Pendant Arm System',
    cover:  pendant6,
    name: "LIFT PENDANT",
    price: 100,
  },
  {
    id: 507,
    category: 'Pendant Arm System',
    cover:   pendant7,
    name: "SINGLE ARM MOTORIZED HEXMOD PENDANT",
    price: 100,
  },
  {
    id: 508,
    category: 'Pendant Arm System',
    cover:   pendant8,
    name: "SINGLE ARM NON-MOTORIZED CALE PENDANT",
    price: 100,
  },
  {
    id: 509,
    category: 'Pendant Arm System',  
    cover:   pendant9,
    name: "TANDEM-PENDANT",
    price: 100,
  },
  {
    id: 510,
    category: 'Pendant Arm System',  
    cover:   pendant10,
    name: "TANDEM-PENDANT",
    price: 100,
  },


//Theatre | Hospital Furniture
  {
    id: 600,
    category: 'Theatre | Hospital Furniture',
    cover: theatre6,
    name: "Orhtopedic Traction Set",
    price: 100,
  },
  {
    id: 601,
    category: 'Theatre | Hospital Furniture',
    cover: theatre7,
    name: "Neurosurgery skull clamp",
    price: 100,
  },
  {
    id: 602,
    category: 'Theatre | Hospital Furniture',
    cover: functionbed,
    name: "2function bed",
    price: 100,
  },
  {
    id: 603,
    category: 'Theatre | Hospital Furniture',
    cover: functionselectricbed,
    name: "5-functions electric bed",
    price: 20,
  },
  {
    id: 604,
    category: 'Theatre | Hospital Furniture',
    cover: gynecologyexaminationbed,
    name: "Gynecology-Examination-Bed",
    price: 200,
  },
  {
    id: 605,
    category: 'Theatre | Hospital Furniture',
    cover: theatre1,
    name: "Manual MultiPurpose OT Table",
    price: 100,
  },
  {
    id: 606,
    category: 'Theatre | Hospital Furniture',
    cover: theatre2,
    name: "Mobile Imaging Table",
    price: 100,
  },
  {
    id: 607,
    category: 'Theatre | Hospital Furniture',
    cover: deliverybed,
    name: "Fully-electrical-delivery-bed",
    price: 50,
  },
  {
    id: 608,
    category: 'Theatre | Hospital Furniture',
    cover: foldingchair,
    name: "Patients Folding Chair",
    price: 100,
  },
  {
    id: 609,
    category: 'Theatre | Hospital Furniture',
    cover: recliningchair,
    name: "IV-RECLINING-CHAIR",
    price: 100,
  },
  {
    id: 610,
    category: 'Theatre | Hospital Furniture',
    cover: manualbed,
    name: "Manual-Nursing-Patient-Hospital-Bed",
    price: 100,
  },
  {
    id: 612,
    category: 'Theatre | Hospital Furniture',
    cover: traumastretcher,
    name: "Trauma-Stretcher",
    price: 100,
  },
  {
    id: 613,
    category: 'Theatre | Hospital Furniture',
    cover: walkingframe,
    name: "Walking Frame",
    price: 100,
  },
  {
    id: 614,
    category: 'Theatre | Hospital Furniture',
    cover: theatre3,
    name: "Mechanical Surgery Table",
    price: 100,
  },
  {
    id: 615,
    category: 'Theatre | Hospital Furniture',
    cover: theatre4,
    name: "Orhtopedic Traction Set. Carbon Fiber",
    price: 100,
  },
  {
    id: 616,
    category: 'Theatre | Hospital Furniture',
    cover: theatre5,
    name: "Rectal positioning set",
    price: 100,
  },
  {
    id: 617,
    category: 'Theatre | Hospital Furniture',
    cover: theatre6,
    name: "Orhtopedic Traction Set",
    price: 100,
  },
  {
    id: 618,
    category: 'Theatre | Hospital Furniture',
    cover: theatre7,
    name: "Neurosurgery skull clamp",
    price: 100,
  },
  {
    id: 619,
    category: 'Theatre | Hospital Furniture',
    cover: theatre8,
    name: "Spinal Cord positioning device",
    price: 100,
  },
  {
    id: 620,
    category: 'Theatre | Hospital Furniture',
    cover: bed1,
    name: "Patient Folding Bed",
    price: 100,
  },
  {
    id: 621,
    category: 'Theatre | Hospital Furniture',
    cover: blinds,
    name: "",
    price: 100,
  },
  {
    id: 622,
    category: 'Theatre | Hospital Furniture',
    cover: cabinets,
    name: "",
    price: 100,
  },


//Chemical Analyzer 
  {
    id: 701,
    category: 'Chemical Analyzer',
    cover: analyser1,
    name: "Auto Hematology Analyzer",
    price: 100,
  },
  {
    id: 702,
    category: 'Chemical Analyzer',
    cover: analyser2,
    name: "Auto Chemistry Analyzer BK-200",
    price: 20,
  },
  {
    id: 703,
    category: 'Chemical Analyzer',
    cover: analyser3,
    name: "Auto Chemistry Analyzer BK-280",
    price: 200,
  },
  {
    id: 704,
    category: 'Chemical Analyzer',
    cover: analyser4,
    name: "Auto Chemistry Analyzer BK-600",
    price: 50,
  },
  {
    id: 705,
    category: 'Chemical Analyzer',
    cover: analyser5,
    name: "Auto ELISA Processor (BIOBASE2000)",
    price: 100,
  },
  {
    id: 706,
    category: 'Chemical Analyzer',
    cover: analyser6,
    name: "Auto ELISA Processor BIOBASE4001",
    price: 100,
  },
  {
    id: 707,
    category: 'Chemical Analyzer',
    cover: analyser7,
    name: "Automatic Veterinary 3-Diff Hematology Analyzer",
    price: 100,
  },
  {
    id: 708,
    category: 'Chemical Analyzer',
    cover: analyser8,
    name: "ELISA Microplate Reader",
    price: 100,
  },
  {
    id: 709,
    category: 'Chemical Analyzer',
    cover: analyser9,
    name: "Elisa Microplate Washer BK-9622",
    price: 100,
  },
  {
    id: 710,
    category: 'Chemical Analyzer',
    cover: analyser10,
    name: "Fluorescence Immunoassay Analyzer BKP2000",
    price: 100,
  },
  {
    id: 711,
    category: 'Chemical Analyzer',
    cover: analyser11,
    name: "Fluorescence Immunoassay Analyzer BKP3000",
    price: 100,
  },
  {
    id: 712,
    category: 'Chemical Analyzer',
    cover: analyser12,
    name: "Microplate Shaker",
    price: 100,
  },
  {
    id: 713,
    category: 'Chemical Analyzer',
    cover: analyser13,
    name: "Semi-auto Chemistry Analyzer",
    price: 100,
  },
  {
    id: 714,
    category: 'Chemical Analyzer',
    cover: analyser14,
    name: "Urine Analyzer",
    price: 100,
  },
  {
    id: 715,
    category: 'Chemical Analyzer',
    cover: analyser15,
    name: "Water Purifier",
    price: 100,
},
  
//Anaesthesia | Respiratory
  {
    id: 801,
    category: 'Anaesthesia | Respiratory',
    cover: ultrasoundtrolley,
    name: "Ultrasound Trolley",
    price: 100,
  },
  {
    id: 802,
    category: 'Anaesthesia | Respiratory',
    cover: anaesthesiamachine,
    name: "Anaesthesia Machine",
    price: 20,
  },
  {
    id: 803,
    category: 'Anaesthesia | Respiratory',
    cover: ultrasoundoxyaider,
    name: " Ultrasound Oxyaider",
    price: 200,
  },
  {
    id: 804,
    category: 'Anaesthesia | Respiratory',
    cover: anaestheticmachine,
    name: "Anaesthetic Machine",
    price: 50,
  },
  {
    id: 805,
    category: 'Anaesthesia | Respiratory',
    cover: ultrasoundmachine,
    name: "3D-Laptop Ultrasound Machine",
    price: 100,
  },
  {
    id: 806,
    category: 'Anaesthesia | Respiratory',
    cover: resuscitator,
    name: "Silicone Manual Resuscitator",
    price: 100,
  },
  {
    id: 807,
    category: 'Anaesthesia | Respiratory',
    cover: ultrasoundtrolley1,
    name: "",
    price: 100,
  },
  {
    id: 808,
    category: 'Anaesthesia | Respiratory',
    cover: ultrasoundtrolley2,
    name: "",
    price: 100,
  },
  {
    id: 809,
    category: 'Anaesthesia | Respiratory',
    cover: HBMaternityMonitor,
    name: "Fetal Dopler Maternity Monitor",
    price: 100,
  },
  {
    id: 810,
    category: 'Anaesthesia | Respiratory',
    cover: BPMonitor,
    name: "Blood Pressure Monitor",
    price: 100,
  },


//Radiology
  {
    id: 901,
    category: 'Radiology',
    cover: xraylow,
    name: "X-RAY RX70 AC Low Frequency",
    price: 100,
  },
  {
    id: 902,
    category: 'Radiology',
    cover: xrayhigh,
    name: "X-RAY RX70 AC High Frequency",
    price: 20,
  },
  {
    id: 903,
    category: 'Radiology',
    cover: xray1,
    name: "CT Scanner",
    price: 200,
  },
  {
    id: 904,
    category: 'Radiology',
    cover: xray2,
    name: "MRI Imaging",
    price: 50,
  },
  {
    id: 905,
    category: 'Radiology',
    cover: xray3,
    name: "Panoramic x-ray film viewer",
    price: 100,
  },
  {
    id: 906,
    category: 'Radiology',
    cover: xray4,
    name: "Wall-mounted X-RAY UNIT",
    price: 100,
  },
  {
    id: 907,
    category: 'Radiology',
    cover: xray5,
    name: "Diagnostic x-ray system",
    price: 100,
  },
  {
    id: 908,
    category: 'Radiology',
    cover: xray6,
    name: "ICU - BRIDGE TYPE",
    price: 100,
  },
  {
    id: 909,
    category: 'Radiology',
    cover: xray7,
    name: "ICU - H TYPE",
    price: 100,
  },
  {
    id: 910,
    category: 'Radiology',
    cover: xray8,
    name: "Suction Unit",
    price: 100,
  },
  {
    id: 911,
    category: 'Radiology',
    cover: xray9,
    name: "HFX 40",
    price: 100,
  },
  {
    id: 912,
    category: 'Radiology',
    cover: xray10,
    name: "",
    price: 100,
  },
  {
    id: 913,
    category: 'Radiology',
    cover: xray11,
    name: "",
    price: 100,
  },


//Medical Lights
  {
    id: 101,
    category: 'Medical Lights',
    cover: light1,
    name: "N-Series",
    price: 100,
  },
  {
    id: 102,
    category: 'Medical Lights',
    cover: light2,
    name: "Observa Alfa-fix",
    price: 20,
  },
  {
    id: 103,
    category: 'Medical Lights',
    cover: light3,
    name: "Observa Alfa-flex",
    price: 200,
  },
  {
    id: 104,
    category: 'Medical Lights',
    cover: light4,
    name: "Observa Prima-flex Goosneck-arm",
    price: 50,
  },
  {
    id: 105,
    category: 'Medical Lights',
    cover: light5,
    name: "Observa Primaled ",
    price: 100,
  },
  {
    id: 106,
    category: 'Medical Lights',
    cover: light6,
    name: "Pentaled 12-28",
    price: 100,
  },
  {
    id: 107,
    category: 'Medical Lights',
    cover: light7,
    name: "Pentaled 63 N",
    price: 100,
  },
  {
    id: 108,
    category: 'Medical Lights',
    cover: light8,
    name: "Pentaled28",
    price: 100,
  },
  {
    id: 109,
    category: 'Medical Lights',
    cover: light9,
    name: "Quattroluci LED",
    price: 100,
  },
  {
    id: 1010,
    category: 'Medical Lights',
    cover: light10,
    name: "Saturno-LED",
    price: 100,
  },
  {
    id: 1011,
    category: 'Medical Lights',
    cover: light11,
    name: "U 29",
    price: 100,
  },
  {
    id: 1012,
    category: 'Medical Lights',
    cover: light12,
    name: "Unica",
    price: 100,
  },
  {
    id: 1013,
    category: 'Medical Lights',
    cover: light13,
    name: "",
    price: 100,
  },


//Dental 
  {
    id: 201,
    category: 'Dental',
    cover: dentalvacuum,
    name: "Dental Vacuum",
    price: 100,
  },
  {
    id: 202,
    category: 'Dental',
    cover: dentalapex,
    name: "Economic-Dental-Apex-Locator-Oxyaider",
    price: 20,
  },
  {
    id: 203,
    category: 'Dental',
    cover: dentalairmotor,
    name: "Dental-Air-Motor-4-Hole-Contra-Angle-Straight-Handpiece",
    price: 200,
  },
  {
    id: 204,
    category: 'Dental',
    cover: aircompressor1,
    name: "1.5EW Oil-free air compressor",
    price: 50,
  },
  {
    id: 205,
    category: 'Dental',
    cover: aircompressor2,
    name: "2EW Oil-free air compressor",
    price: 100,
  },
  {
    id: 206,
    category: 'Dental',
    cover: aircompressor3,
    name: "3EW Oil-free air compressor",
    price: 100,
  },
  {
    id: 207,
    category: 'Dental',
    cover: aircompressor4,
    name: "Dental-Bone",
    price: 100,
  },
  {
    id: 208,
    category: 'Dental',
    cover: aircompressor5,
    name: "Silent-Dental-Air-Compresor",
    price: 100,
  },
  {
    id: 209,
    category: 'Dental',
    cover: dentalchair1,
    name: "TS-PRO208 Plus",
    price: 100,
  },
  {
    id: 2010,
    category: 'Dental',
    cover: dentalchair2,
    name: "TS-TOP300 Folding",
    price: 100,
  },
  {
    id: 2011,
    category: 'Dental',
    cover: dentalchair3,
    name: "TS-TOP301 Standard",
    price: 100,
  },
  {
    id: 2012,
    category: 'Dental',
    cover: dentalchair4,
    name: "TS-TOP301 ROTARY",
    price: 100,
  },
  {
    id: 2013,
    category: 'Dental',
    cover: dentalchair5,
    name: "Dental-Unit-Chair",
    price: 100,
  },
  {
    id: 2014,
    category: 'Dental',
    cover: dentalchair6,
    name: "Medical-Dental-Unit-Full-Set",
    price: 100,
  },
  {
    id: 2015,
    category: 'Dental',
    cover: aircompressor6,
    name: "Air-Plus 1",
    price: 50,
  },
  {
    id: 2016,
    category: 'Dental',
    cover: aircompressor7,
    name: "Air-Pro 1",
    price: 100,
  },
  {
    id: 2017,
    category: 'Dental',
    cover: aircompressor8,
    name: "3-EW",
    price: 100,
  },
  {
    id: 2018,
    category: 'Dental',
    cover: dentalchair7,
    name: "",
    price: 100,
  },


//Biosafety Cabinet 
  {
    id: 3001,
    category: 'Biosafety Cabinet',
    cover: cabinet1,
    name: "Class I Biological Safety Cabinet",
    price: 100,
  },
  {
    id: 3002,
    category: 'Biosafety Cabinet',
    cover:   cabinet2,
    name: "Class II A2 Biological Safety Cabinet",
    price: 100,
  },
  {
    id: 3003,
    category: 'Biosafety Cabinet',
    cover:   cabinet3,
    name: "Class III Biological Safety Cabinet Level 3",
    price: 100,
  },
  {
    id: 3004,
    category: 'Biosafety Cabinet',
    cover:   cabinet4,
    name: "Class III Biological Safety Cabinet",
    price: 100,
  },
  {
    id: 3005,
    category: 'Biosafety Cabinet',
    cover:   cabinet5,
    name: "Class Ⅱ Biological Safety Cabinet 11231 PRO",
    price: 100,
  },
  {
    id: 3006,
    category: 'Biosafety Cabinet',
    cover:   cabinet6,
    name: "Cytotoxic Safety Cabinet",
    price: 100,
  },
  {
    id: 3007,
    category: 'Biosafety Cabinet',
    cover:   cabinet7,
    name: "Double-side Class II A2 Biological Safety Cabinet",
    price: 100,
  },
  {
    id: 3008,
    category: 'Biosafety Cabinet',
    cover:   cabinet8,
    name: "EN Certified Biological Safety Cabinet",
    price: 100,
  },
  {
    id: 3009,
    category: 'Biosafety Cabinet',
    cover:   cabinet9,
    name: "New EN Certified Biological Safety Cabinet BSC-2FA2-HA",
    price: 100,
  },


//Monitors
  {
    id: 4001,
    category: 'Monitors',
    cover: monitor1,
    name: "Monochrome Monitors",
    price: 100,
  },
  {
    id: 4002,
    category: 'Monitors',
    cover: monitor2,
    name: "Touch Panel Color Monitors",
    price: 20,
  },
  {
    id: 4003,
    category: 'Monitors',
    cover: monitor3,
    name: "Hybrid Medical Display",
    price: 200,
  },
  {
    id: 4004,
    category: 'Monitors',
    cover: monitor4,
    name: "Mammography Display Monitor",
    price: 50,
  },
  {
    id: 4005,
    category: 'Monitors',
    cover: monitor5,
    name: "Medical Display Monitor",
    price: 100,
  },
  {
    id: 4006,
    category: 'Monitors',
    cover: monitor6,
    name: "Surgical Medical Monitor",
    price: 100,
  },
  {
    id: 4007,
    category: 'Monitors',
    cover: monitor7,
    name: "Diagnostic Medical Monitor",
    price: 100,
  },


//Suction Machine
  {
    id: 5001,
    category: 'Suction Machine',
    cover: suction1,
    name: "Smart-Power 1",
    price: 100,
  },
  {
    id: 5002,
    category: 'Suction Machine',
    cover: suction2,
    name: "Surgical-Suction-Emivac",
    price: 20,
  },
  {
    id: 5003,
    category: 'Suction Machine',
    cover: suction3,
    name: "Surgical-Suction-Flovac-Trolley",
    price: 200,
  },
  {
    id: 5004,
    category: 'Suction Machine',
    cover: suction4,
    name: "Surgical-Suction-Hospivac",
    price: 50,
  },


//CSSD
  {
    id: 6001,
    category: 'CSSD',
    cover: cssd1,
    name: "Portable Pressure Steam-Autoclave",
    price: 100,
  },
  {
    id: 6002,
    category: 'CSSD',
    cover: cssd2,
    name: "Electrothermal Pressure steam-sterilizer",
    price: 20,
  },
  {
    id: 6003,
    category: 'CSSD',
    cover: cssd3,
    name: "Portable Steam-Autoclave",
    price: 200,
  },
  {
    id: 6004,
    category: 'CSSD',
    cover: cssd4,
    name: "Portable-Sterilizer",
    price: 50,
  },
  {
    id: 6005,
    category: 'CSSD',
    cover: cssd5,
    name: "Sterilizer Portable-Autoclave",
    price: 100,
  },
  {
    id: 6006,
    category: 'CSSD',
    cover: cssd6,
    name: "UV-Sterilizer",
    price: 100,
  },
  {
    id: 6007,
    category: 'CSSD',
    cover: cssd7,
    name: "Ultrasonic-Scaler-A2",
    price: 100,
  },
  {
    id: 6008,
    category: 'CSSD',
    cover: cssd8,
    name: "Class B Steam Steriliser",
    price: 100,
  },
  {
    id: 6009,
    category: 'CSSD',
    cover: cssd9,
    name: "Water Distiller",
    price: 100,
  },

];
export default allProducts